import React, { useEffect, useState } from "react";
import { FiExternalLink } from "react-icons/fi";
import "../style/designPrototypeCard.css";

const DesignPrototypeCard = ({
  image,
  images = [],
  title,
  languages,
  description,
  link,
  isActive = true,
  layout = "image-left",
  isExpanded,
  onToggle,
}) => {
  const slideshowImages = images.length > 0 ? images : [image].filter(Boolean);
  const technologies = languages.split(/\s*(?:,|and)\s*/i).filter(Boolean);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const showPreviousImage = () => {
    setCurrentImageIndex(
      (currentIndex) =>
        (currentIndex - 1 + slideshowImages.length) % slideshowImages.length,
    );
  };
  const showNextImage = () => {
    setCurrentImageIndex(
      (currentIndex) => (currentIndex + 1) % slideshowImages.length,
    );
  };
  useEffect(() => {
    setCurrentImageIndex(0);

    if (slideshowImages.length <= 1 || !isActive) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setCurrentImageIndex(
        (currentIndex) => (currentIndex + 1) % slideshowImages.length,
      );
    }, 3000);

    return () => window.clearInterval(intervalId);
  }, [images, image, isActive, slideshowImages.length]);

  return (
    <article className={`design-card ${layout}`}>
      <div className="design-card-gallery">
        <div className="design-card-slideshow">
          <div
            className="design-card-track"
            style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
          >
            {slideshowImages.map((slideshowImage, index) => (
              <div
                className="design-card-slide"
                key={`${slideshowImage}-${index}`}
              >
                <img
                  src={slideshowImage}
                  alt={`${title} preview ${index + 1}`}
                  className="design-card-image"
                />
              </div>
            ))}
          </div>

          {slideshowImages.length > 1 && (
            <>
              <button
                type="button"
                className="design-card-arrow previous"
                aria-label={`Show previous ${title} image`}
                onClick={showPreviousImage}
              >
                &#8249;
              </button>
              <button
                type="button"
                className="design-card-arrow next"
                aria-label={`Show next ${title} image`}
                onClick={showNextImage}
              >
                &#8250;
              </button>
            </>
          )}
        </div>

        {slideshowImages.length > 1 && (
          <div className="design-card-dots" aria-label={`${title} slides`}>
            {slideshowImages.map((slideshowImage, index) => (
              <button
                key={`${slideshowImage}-dot-${index}`}
                type="button"
                className={`design-card-dot ${
                  index === currentImageIndex ? "active" : ""
                }`}
                aria-label={`Show ${title} image ${index + 1}`}
                aria-current={index === currentImageIndex ? "true" : undefined}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        )}
      </div>

      <div className="design-card-content">
        <h2 className="design-card-title">{title}</h2>
        <p className="design-card-languages">
          <span>
            {technologies.length === 1 ? "Technology:" : "Technologies:"}
          </span>
          {languages.includes("Figma") && (
            <span className="design-card-figma-icon" aria-hidden="true">
              <span className="figma-shape figma-red" />
              <span className="figma-shape figma-orange" />
              <span className="figma-shape figma-purple" />
              <span className="figma-shape figma-blue" />
              <span className="figma-shape figma-green" />
            </span>
          )}
          <span>{languages}</span>
        </p>

        <p
          className={`design-card-description ${
            isExpanded ? "expanded" : "collapsed"
          }`}
          onClick={onToggle}
        >
          {description}
        </p>

        <a
          href={link}
          className="design-card-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiExternalLink className="design-card-link-icon" aria-hidden="true" />
          View project
        </a>
      </div>
    </article>
  );
};

export default DesignPrototypeCard;
